'use strict';

export default class MemTransactionListCtrl {
  constructor($stateParams, $location, $filter, $window, LoaderSvc, moment,
    DatetimeSvc, GroupSvc, GroupAuthSvc, MemTxnSvc) {
    LoaderSvc.start('Loading Member Transactions...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var personId = $stateParams.perId;
    this.personId = personId; // set for group urls

    // authorization
    GroupAuthSvc.validatePermission(ctxId, 'memberTransaction', 'I');

    that.dataModel = 'mtvm';

    that.memberTransactions;
    // get time periods
    GroupSvc.getTimePeriods({groupId: ctxId}).$promise
      .then(function(tp) {
      // ignore values without effective start
        var today = moment();
        tp = tp.filter(function(per) {
          return per.effectiveStart
          && today.isSameOrAfter(DatetimeSvc.parseUTCDate(per.effectiveStart));
        });
        tp.push({id: '', name: 'All Years'});
        tp = $filter('orderBy')(tp, 'start', true);
        // initialize time periods with current time period
        // refresh filter with updates to query params
        for(var i = 0; i < tp.length; i++) {
          var per = tp[i];
          var effectiveStart = per.effectiveStart || per.start;
          if(today.isSameOrAfter(effectiveStart)
        && today.isSameOrBefore(DatetimeSvc.parseUTCDate(per.end, true))) {
            that.tpFilter = per.id;
            break;
          }
        }
        that.timePeriods = tp;
      })
      .then(function() { that.loadMemTxn(); });

    that.loadMemTxn = function() {
      // get transactions
      return MemTxnSvc.query({groupId: ctxId, personId}).$promise
        .then(function(mt) {
        // map time periods for filtering
          mt.forEach(function(d) {
            if(d.utcDate) {
            //eslint-disable-next-line newline-per-chained-call
              var dateStr = moment(d.utcDate).utcOffset(0).format('YYYY-MM-DD');
              d.date = moment(dateStr).valueOf();
            }
          });
          that.memberTransactions = mt;
          that.filterMemTxn();
          that.order = 'date';
          that.searchField = 'name';
          LoaderSvc.stop();
        })
        .catch(function() {
          LoaderSvc.stopError('Error loading Member Transactions');
        });
    };

    that.filterMemTxn = function() {
      that.data = $filter('filter')(that.memberTransactions,
        {timePeriodId: that.tpFilter});
    };

    that.invoice = function(memTxn) {
      // confirm dues
      if(memTxn.memberFee.type === 'dues') {
        var msg = 'Are you sure you want to invoice these dues?'
        + ' This may include associated late fees.'
        + ' Once invoiced, adjustments will have to be applied manually.';
        if($window.confirm(msg)) {
          MemTxnSvc.invoiceDues({
            groupId: memTxn.fromGroup.id,
            personId,
            memberFeeId: memTxn.memberFee.id
          }).$promise
            .then(function() { that.loadMemTxn(); });
        }
      }
    };
  }
}

MemTransactionListCtrl.$inject = [
  '$stateParams',
  '$location',
  '$filter',
  '$window',
  'LoaderSvc',
  'moment',
  'DatetimeSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'MemTxnSvc'
];
